export default [
  {
    id: 1,
    type: '医疗健康',
    name: '微医',
    image: require('../assets/customerCaseImage/01.png'),
    img: require('../assets/resolution/companyImg/c_wy.png'),
    intro: '微医（挂号网）是国家卫生和计划生育委员会批准的全国就医指导及健康咨询平台和国际领先的移动医疗服务平台。面临日益增长的业务体量，如何链接千万医生和亿级患者成了微医业务发展过程中的重中之重。',
    markdown: require('./customerCaseMarkdown/微医.md'),
    url: '/case/weiyi',
  },
  {
    id: 2,
    type: '医疗健康',
    name: '邵逸夫医院',
    image: require('../assets/customerCaseImage/02.png'),
    img: require('../assets/resolution/companyImg/c_syf.png'),
    intro: '浙江大学医学院附属邵逸夫医院是集医疗、教学和科研为一体的公立综合性三级甲等医院。2020年疫情爆发之初，邵逸夫医院积极做好新冠疫情防控工作，充分利用现代信息技术，全力推进网上办公、网上教学。第一时间上线规范化培训线上管理系统项目，该项目由马兰头医学科技承建，为医院开发并实施住院医师规范化培训管理系统。',
    markdown: require('./customerCaseMarkdown/邵逸夫医院.md'),
    url: '/case/syfyy',
  },
  {
    id: 3,
    type: '医疗健康',
    name: '明天医网',
    image: require('../assets/customerCaseImage/03.png'),
    img: require('../assets/resolution/companyImg/c_mtyw.png'),
    intro: '宁波明天医网科技有限公司是一家专业从事医疗软件研发和生产，提供信息技术咨询和计算机医疗信息系统集成服务的高科技企业。在国内拥有县级以上医院的PACS用户300多家，区域卫生信息化系统用户近100家，国内医院总用户数近1500家。',
    markdown: require('./customerCaseMarkdown/明天医网.md'),
    url: '/case/mtyw',
  },
  {
    id: 4,
    type: '医疗健康',
    name: '好乐医',
    image: require('../assets/customerCaseImage/04.png'),
    intro: '好乐医同时服务医生与患者。马兰头为移动医疗APP”易转诊“嵌入马兰头融合视讯云引擎，提供视频咨询，优化医生和患者使用体验。',
    markdown: require('./customerCaseMarkdown/好乐医.md'),
    url: '/case/hly',
  },
  {
    id: 5,
    type: '医疗健康',
    name: '国家中医药管理局',
    image: require('../assets/customerCaseImage/05.png'),
    intro: '国家中医药管理局是政府管理中医药行业的国家机构，隶属于国家卫生和计划生育委员会。国家中医药管理局领导对马兰头视频会议系统做出高度评价，在这次超过300家单位参加的培训和会议上，声音和图像均清晰流畅。',
    markdown: require('./customerCaseMarkdown/国家中医药管理局.md'),
    url: '/case/gjzyyglj',
  },
  {
    id: 6,
    type: '教育',
    name: '朗朗课堂',
    image: require('../assets/customerCaseImage/06.png'),
    img: require('../assets/resolution/companyImg/c_llkt.png'),
    intro: '朗朗课堂为中国电信公司旗下一款专注致力于K12线上教育的教育平台。马兰头作为专业的视频通讯云服务商，提供成熟的视讯SDK，在音视频质量、图文实时协作、流量控制技术已经达到业界领先水平，让朗朗课堂坚信，其所提供的音视频能力一定是界内数一数二的。',
    markdown: require('./customerCaseMarkdown/朗朗课堂.md'),
    url: '/case/llkt',
  },
  {
    id: 7,
    type: '教育',
    name: 'Q学友',
    image: require('../assets/customerCaseImage/07.png'),
    img: require('../assets/resolution/companyImg/c_xy.png'),
    intro: 'Q学友是专注于职业培训的线上线下混合式智慧教育云平台。作为智慧培训领导者，一直坚持帮助学校、培训机构、企业实现从线下到线上的教学转型升级，为各类合作伙伴提供线上线下混合式教培系统。',
    markdown: require('./customerCaseMarkdown/Q学友.md'),
    url: '/case/qxy',
  },
  {
    id: 8,
    type: '教育',
    name: '咪咕学堂',
    image: require('../assets/customerCaseImage/08.png'),
    intro: '“咪咕学堂”是由咪咕数字传媒有限公司面向中小学、职业、出国留学和幼儿教育类学习群体，打造的一站式贴心学习服务平台。提供海量优质学习资源，包括直播课程、视频课程；整合学习兴趣圈等互动能力，创新“练学测疑”闭环型微学习模式。',
    markdown: require('./customerCaseMarkdown/咪咕学堂.md'),
    url: '/case/mgxt',
  },
  {
    id: 9,
    type: '教育',
    name: '网易云课堂',
    image: require('../assets/customerCaseImage/09.png'),
    intro: '网易公司(163.com)旗下实用技能学习平台。与优秀讲师、专业机构、院校合作，提供海量优质课程，以及创新的在线学习体验。',
    markdown: require('./customerCaseMarkdown/网易云课堂.md'),
    url: '/case/wyykt',
  },
  {
    id: 10,
    type: '通信',
    name: '中国电信',
    image: require('../assets/customerCaseImage/10.png'),
    intro: '中国电信是全球规模最规模最大的电信运营企业之一。其首批在海外上市的四家省级公司之一的中国电信浙江分公司目前下辖11个市分公司、62个县（市、区）分公司、1个直属单位（省长途电信传输局）、2个专业分公司（省公用电话分公司、省号码百事通信息服务分公司，控股公众信息产业有限公司、公众信息集成有限公司。',
    markdown: require('./customerCaseMarkdown/中国电信.md'),
    url: '/case/zgdx',
  },
  {
    id: 11,
    type: '通信',
    name: '中国移动',
    image: require('../assets/customerCaseImage/11.png'),
    intro: '中国移动通信集团公司（简称“中国移动”）于 2000年4月20日成立，注册资本3,000亿元人民币，资产规模超过1.72万亿人民币，客户总数8.5亿，基站总数超300万个，是全球网络规模、客户规模最大、市值排名领先的电信运营企业。',
    markdown: require('./customerCaseMarkdown/中国移动.md'),
    url: '/case/zgyd',
  },
  {
    id: 12,
    type: '通信',
    name: '中国联通',
    image: require('../assets/customerCaseImage/12.png'),
    intro: '中国联合网络通信集团有限公司（简称中国联通）于2009年1月6日在原中国网通和原中国联通的基础上合并而成，在国内31个省（自治区、直辖市）和境外多个国家和地区设有分支机构，是中国唯一一家同时在纽约、香港、上海三地上市的电信运营企业。',
    markdown: require('./customerCaseMarkdown/中国联通.md'),
    url: '/case/zglt',
  },
  {
    id: 13,
    type: '其他',
    name: '朗新科技',
    image: require('../assets/customerCaseImage/13.png'),
    img: require('../assets/resolution/companyImg/c_lx.png'),
    intro: '朗新科技聚焦产业互联网，采用新一代信息技术打造“产业互联网应用引擎”。马兰头医学科技IM PaaS平台助力朗新科技电力生产检修及智能监管工作中一线操作人员与后台支持人员等各部门快速构建协同平台，实现单聊、群组聊天等协同功能。',
    markdown: require('./customerCaseMarkdown/朗新科技.md'),
    url: '/case/lxkj',
  },
  {
    id: 14,
    type: '其他',
    name: '网易云会议',
    image: require('../assets/customerCaseImage/14.png'),
    intro: '网易云会议是网易企业邮箱团队推出的一款基于云计算技术的高效、便捷、实惠的视频会议产品，借助云会议，机构可降低费用成本、提高沟通效率。用户仅需联网电脑，即可快速召开、接入视频会议，无需专用硬件设备，不受地域限制影响。',
    markdown: require('./customerCaseMarkdown/网易云会议.md'),
    url: '/case/wyyhy',
  },
  {
    id: 15,
    type: '其他',
    name: '浙江华数',
    image: require('../assets/customerCaseImage/15.png'),
    intro: '浙江华数广电网络股份有限公司以华数数字电视传媒集团有限公司为基础，省、市、县（市、区）广播电视播出机构共同参与、一体化运营组建，是浙江省级广播电视网络公司和省属国有股份制文化骨干企业。',
    markdown: require('./customerCaseMarkdown/浙江华数.md'),
    url: '/case/zjhs',
  },
  {
    id: 16,
    type: '其他',
    name: '致群股份',
    image: require('../assets/customerCaseImage/16.png'),
    img: require('../assets/resolution/companyImg/c_zqgf.png'),
    intro: '通过集成马兰头底层音视频和IM即时通讯能力，为公安部队警用智能眼镜提供专业的通信服务。将执法记录、语音通讯、人体测温，数据显示，图像识别，指挥调度等融为一体。有效提升一线警务人员的工作效率。\n',
    url: '',
  },
]
